import { Flex } from '@fluentui/react-northstar';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import * as React from 'react';
import "react-multi-carousel/lib/styles.css";
import { useDispatch } from 'react-redux';
import envConfig from '../../config';
import { HubFile } from '../../model';
import { useTypedSelector } from '../../store';
import { ApplicationState } from '../../store/appThunkAction';
import { getFile, getStory } from '../../store/Story/actions';
import { Bookmark, File } from '../../store/Story/modal';
import styles from './index.module.scss';
import BookmarkSidepanelItem from './sidepanel-Item';

const BookmarkSidepanelContainer = () => {
    const dispatch = useDispatch();

    const {
        stories: cacheStories,
        files: cacheFiles,
    } = useTypedSelector((state: ApplicationState) => state.story);

    const {
        bookmarks: items        
    } = useTypedSelector((state: ApplicationState) => state.bookmark);  

    React.useEffect(() => {
        items.forEach((bookmarkItem) => {
            if (bookmarkItem) {
                bookmarkItem.setData.forEach((currentItem) => {
                    if (currentItem.type === 'story') {
                        if (!cacheStories[currentItem.permId]) {
                            dispatch(getStory(currentItem.permId));
                        }
                    } else {
                        if (!cacheFiles[currentItem.id]) {
                            dispatch(getFile(currentItem.id));
                        }

                    }
                })
            }
        })

    }, [items]);

    const filterBookmarks: Bookmark[] = (items || []).map((item) => {
        if (item.setData.length > 0) {
            const allFiles = item.setData.filter(c => c.type === 'file').length === item.setData.length;
            if (allFiles) {
                const files = item.setData.filter((c: any) => envConfig.invalidCategory.indexOf(c.category) < 0) as unknown as File[];
                if (files.length > 0) {
                    const mapFiles = files.map(file => cacheFiles[file.id]).filter(c => !!c);
                    if (mapFiles.length > 0) {
                        return {
                            id: item.id,
                            name: item.name,
                            storyId: mapFiles[0].permId,
                            thumbnail: mapFiles[0].thumbnail,
                            files: mapFiles
                        }
                    }
                }
                return null;
            } else if (item.setData[0].type === 'story') {
                const storyDetails = cacheStories[item.setData[0].permId];
                if (storyDetails) {

                    const files = storyDetails.files.filter((c: any) => envConfig.invalidCategory.indexOf(c.category) < 0) as unknown as File[];
                    if (files.length > 0) {
                        return {
                            id: item.id,
                            name: item.name,
                            storyId: storyDetails.perm_id,
                            thumbnail: files[0].cover_art_url,
                            files: files.map(file => {
                                return {
                                    id: file.id,
                                    category: file.category,
                                    thumbnail: file.cover_art_url,
                                    createdAt: file.created_at,
                                    description: file.description,
                                    excerpt: file.description,
                                    filePermId: file.id,
                                    permId: storyDetails.perm_id
                                } as unknown as HubFile;
                            })
                        }
                    }
                }
            }

        }
        return null;
    }).filter(c => c !== null) as unknown as Bookmark[];
       
    return (
        <Flex column className={styles.root}>
            <Stack.Item className={styles.bookmarksTitle}>
                Bookmarks
            </Stack.Item>
            <Stack.Item grow={1} className={styles.list}>
                {filterBookmarks.map((item) => {
                    return <BookmarkSidepanelItem key={item.id} {...item} />
                })}
            </Stack.Item>
        </Flex>
    )
};
export default BookmarkSidepanelContainer